import { modelExtensionTypes } from '@services/toys/helpers'

export const getModelPath = (hash: string, type: modelExtensionTypes) => ` https://s3.r.toys/toys/models/${hash}/scene.${type}`
